"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutPictureBox = void 0;
var tslib_1 = require("tslib");
var layout_box_1 = require("./layout-box");
var LayoutPictureBox = (function (_super) {
    tslib_1.__extends(LayoutPictureBox, _super);
    function LayoutPictureBox(characterProperties, colorInfo, cacheInfo, size) {
        var _this = _super.call(this, characterProperties, colorInfo) || this;
        _this.cacheInfo = cacheInfo;
        _this.width = size.width;
        _this.height = size.height;
        _this.isLoaded = _this.cacheInfo.isLoaded;
        return _this;
    }
    LayoutPictureBox.prototype.equals = function (obj) {
        return _super.prototype.equals.call(this, obj) && this.cacheInfo.equals(obj.cacheInfo) && this.isLoaded == obj.isLoaded;
    };
    LayoutPictureBox.prototype.clone = function () {
        var newObj = new LayoutPictureBox(this.characterProperties, this.colorInfo, this.cacheInfo, this.createSize());
        newObj.copyFrom(this);
        return newObj;
    };
    LayoutPictureBox.prototype.getType = function () {
        return layout_box_1.LayoutBoxType.Picture;
    };
    LayoutPictureBox.prototype.pushInfoForMeasure = function (_info, _showHiddenSymbols) { };
    LayoutPictureBox.prototype.popInfoForMeasure = function (_info, _showHiddenSymbols) { };
    LayoutPictureBox.prototype.getAscent = function () {
        return this.height;
    };
    LayoutPictureBox.prototype.getDescent = function () {
        return 0;
    };
    LayoutPictureBox.prototype.isVisible = function () {
        return true;
    };
    LayoutPictureBox.prototype.isVisibleForRowAlign = function () {
        return true;
    };
    LayoutPictureBox.prototype.renderGetContent = function (renderer) {
        return renderer.renderPictureBoxContent(this.createSize(), this.cacheInfo, this.hyperlinkTip);
    };
    LayoutPictureBox.prototype.isWhitespace = function () {
        return false;
    };
    LayoutPictureBox.prototype.isLineBreak = function () {
        return false;
    };
    return LayoutPictureBox;
}(layout_box_1.LayoutBox));
exports.LayoutPictureBox = LayoutPictureBox;
